import moment from 'moment';

import { IAdminEvent } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventRound } from '../../eventRounds/store';

export const editRound = async (
  state: IStore,
  clubId: number,
  event: IAdminEvent,
  round: IEventRound
) => {
  let body: any = {
    ...round
  };

  if (!!round.course) {
    body = { ...body, course: round.course.id ? round.course.id : round.course };
  }

  if (!!round.start) {
    body = { ...body, start: moment(round.start).format('YYYY-MM-DDTHH:mm:ssZ') };
  }

  if (!!round.teeFrequency) {
    body = { ...body, teeFrequency: 60 * Number(round.teeFrequency) };
  }

  delete body.teeAssignments;
  delete body.groups;

  const response = await request.patch(
    `${api.admin.events(clubId)}${event.id}/rounds/${round.id}/`,
    body
  );

  if (response.error) {
    return { errors: { events: { msg: 'Error Editing the event round.' } } };
  }

  if (!clubId) {
    return state;
  }

  const currentRound = state.adminEvents[event.id].rounds.find(r => r.id === round.id);

  const newRound = {
    ...currentRound,
    ...response
  };

  const start = newRound.order === 0 ? newRound.start : event.start;
  const newEvent = {
    ...event,
    rounds: event.rounds.map(eventRound => (eventRound.id !== round.id ? eventRound : newRound)),
    start
  };

  return {
    adminEventRounds: {
      ...state.adminEventRounds,
      [newRound.id]: newRound
    },
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [newEvent.id]: newEvent
      },
      current: newEvent,
      [newEvent.id]: newEvent
    }
  };
};
